module.exports = __webpack_public_path__ + "images/internal/datashake/angies_list.png";